import React from 'react';
import postCreateStyle from '../../components/post-create.module.scss';

export const Info = ({ text = '' }) => {
  if (!text || text.length <= 0) return null;

  return <span className={postCreateStyle.info}>{text}</span>;
};
